import { getOSName, openPhone, sendEmail, sendText } from "./send";

export const SendUtilities = {
	/**
 * Returns the name of the user's operating system.
 */
	getOSName: () => getOSName(),

	/**
	 * Opens the user's default email client with a new message to the specified email(s).
	 * @param emails A single email or an array of emails.
	 */
	sendEmail: (emails: string | string[]) => sendEmail(emails),

	/**
	 * Opens the user's default SMS app with a new message to the specified phone number(s).
	 * @param phones A single phone number or an array of phone numbers.
	 * @param os Optional. The user's operating system ('ios', 'macos', etc.).
	 */
	sendText: (phones: string | string[]) => sendText(phones),

	/**
	 * Opens the user's default phone app with a new call to the specified phone number.
	 * Only a single phone number is allowed.
	 * @param phone A single phone number.
	 */
	openPhone: (phone: string) => openPhone(phone)
}